// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1b1bb0e8","453":"fa1d4005","455":"ea4321bb","977":"36fa450b"}[chunkId] + ".chunk.js";
};